import { useState } from "react";
import Button, {
  ButtonColorTypes,
  ButtonTypes,
} from "../shared-components/Button";
import InputField from "../shared-components/InputField";
import LoadingSpinner from "../shared-components/LoadingSpinner";
import { classNames } from "../utils";
import { getProfileUrlValidation } from "../utils/personFieldLimits";

type ProfileAddProps = {
  handleAddProfile: (inputURL: string) => void;
  validateProfile?: (inputURL: string) => Promise<string>;
  isValidating?: boolean;
};

const ProfileAdd = ({
  handleAddProfile,
  validateProfile,
  isValidating = false,
}: ProfileAddProps) => {
  const [inputUrl, setInputUrl] = useState("");
  const [errorMessage, setErrorMessage] = useState<string>("");

  async function handleSubmit() {
    const local = getProfileUrlValidation(inputUrl);
    if (!local.ok) {
      setErrorMessage(local.message);
      return;
    }
    const normalized = local.normalized;
    setInputUrl(normalized);
    if (validateProfile) {
      try {
        const errorStr = await validateProfile(normalized);
        if (errorStr && errorStr.length > 0) {
          setErrorMessage(errorStr);
          return;
        }
      } catch {
        // Transport failure: local URL is already valid; add anyway.
      }
    }
    handleAddProfile?.(normalized);
    setInputUrl("");
    setErrorMessage("");
  }

  function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
    const value = e.target.value;
    setInputUrl(value);
    const result = getProfileUrlValidation(value, { allowEmpty: true });
    setErrorMessage(result.ok ? "" : result.message);
  }

  return (
    <>
      <div className="flex flex-row border border-solid rounded-md items-center w-full">
        <InputField
          handleChange={handleInputChange}
          name={"note input"}
          placeholder="Enter profile URL"
          classes="w-full"
          className={classNames(
            "mb-0  w-full",
            errorMessage ? "border-red-500" : "border-none"
          )}
          value={inputUrl}
        />
        <Button
          text={
            isValidating ? (
              <span className="flex items-center justify-center w-full">
                <LoadingSpinner className="h-5 w-5" />
              </span>
            ) : (
              "Add"
            )
          }
          onClick={handleSubmit}
          colorType={ButtonColorTypes.custom}
          type={ButtonTypes.add}
          className="border-l p-0 w-20 bg-gray-50 rounded-l-none"
          disabled={isValidating}
        />
      </div>
      {errorMessage && (
        <div className="text-red-500 ml-2 mt-1">{errorMessage}</div>
      )}
    </>
  );
};

export default ProfileAdd;
